import React, { useState, useEffect } from "react";
import { Button, Spin } from "antd";
import { useParams } from "react-router";
import { ReactSVG } from "react-svg";
import mapboxPolyline from "@mapbox/polyline";
import socketIOClient from "socket.io-client";

import "./LiveTracking.scss";
import DefaultMapbox from "../Mapbox/DefaultMapbox";
import markerIcons from "../Markers/markerIcons";
import Container from "../../modules/liveTracking/container";

const socketURI = process.env.REACT_APP_SOCKET_URI || "";
const socket = socketIOClient(socketURI);

const markerDriver = (
  <div className="marker--driver">
    <img src={markerIcons["liveDriver"]["7732EF"]} style={{ width: 34, height: 38 }} alt="" />
  </div>
);
const markerStop = (
  <div className="marker">
    <img src={markerIcons["order"]["7732EF"]} style={{ width: 34, height: 38 }} alt="" />
  </div>
);

const LiveTrackingPage = ({ isFetching, liveTrackingData, doDetailLiveTracking, doDetailLiveTrackingNoFetching }) => {
  const [moveToPoint, setMoveToPoint] = useState(undefined);
  const { stopId } = useParams();

  console.log("stopId", stopId);
  console.log("isFetching", isFetching);
  console.log("liveTrackingData", liveTrackingData);
  const driverId = liveTrackingData?.driverId;
  const markers = [];
  const polylines = [];

  if (liveTrackingData?.driverLat && liveTrackingData?.driverLng) {
    markers.push({
      content: markerDriver,
      latitude: liveTrackingData?.driverLat,
      longitude: liveTrackingData?.driverLng,
      offsetLeft: -17,
      offsetTop: -17,
    });
  }
  if (liveTrackingData?.orderLat && liveTrackingData?.orderLng) {
    markers.push({
      content: markerStop,
      latitude: liveTrackingData?.orderLat,
      longitude: liveTrackingData?.orderLng,
      offsetLeft: -17,
      offsetTop: -17,
    });
  }

  if (liveTrackingData?.polyline) {
    const polyline = liveTrackingData?.polyline;
    const points = mapboxPolyline.decode(polyline);
    const pathCoordinate = points.map(x => {
      return { lat: x[0], lng: x[1] };
    });
    polylines.push({
      points: pathCoordinate,
      strokeColor: "#7732EF",
      strokeWeight: 2,
      strokeOpacity: 0.8,
    });
  }

  useEffect(() => {
    socket.connect();
    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    doDetailLiveTracking(stopId);
  }, [stopId]);

  useEffect(() => {
    socket.off(driverId).on(driverId, data => {
      if (data.event === "driver.changing.location") {
        doDetailLiveTrackingNoFetching(stopId);
      }
    });
  }, [driverId]);

  return (
    <Spin spinning={isFetching}>
      <div className="LiveTrackingPage">
        <DefaultMapbox
          markers={markers}
          polylines={polylines}
          moveToPoint={moveToPoint}
          resetMoveToPoint={() => setMoveToPoint(undefined)}
        />
        <div className="InfoTracking">
          <div className="Title">The driver is on the way</div>
          <div className="Address">{liveTrackingData?.orderAddress}</div>
          <div className="Actions">
            <div className="Eta">
              <div className="EtaLeft">
                <ReactSVG className="icon" src="/icons/eta.svg" />
              </div>
              <div className="EtaRight">
                <div className="EtaText">ETA</div>
                <div className="EtaTime">{liveTrackingData?.orderEta}</div>
              </div>
            </div>
            <a href={`tel:${liveTrackingData?.phone}`}>
              <Button type="primary" size="large">
                Call <ReactSVG className="icon" src="/icons/call.svg" />
              </Button>
            </a>
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default Container(LiveTrackingPage);
